import * as React from 'react';

import { Container, Header, Content } from './styled';

export const Page: PageType = ({ children, ...props }) => {
  return (
    <Container {...props}>
      {children}
    </Container>
  );
};

Page.Header = (props) => {
  return <Header {...props} />;
};

Page.Content = (props) => {
  return <Content {...props} />;
};

type PageType = React.FC<{ children: React.ReactNode }> & {
  Header: React.FC<{ children: React.ReactNode }>;
  Content: React.FC<ContentProps>;
};

type ContentProps = {
  center?: boolean;
  backgroundImage?: string;
  dark?: boolean;
  noFooter?: boolean;
  large?: boolean;
  children: React.ReactNode;
};
